import { ArrowRight } from 'lucide-react';
import { CAMPAIGNS } from '../lib/pricing';
import { useOrder } from '../context/OrderContext';
import SectionHead from './SectionHead';
import { Stagger, Item } from '../lib/motion';

export default function CampaignsSection() {
  const { selectCampaign, order } = useOrder();
  const selected = order.kind === 'campaign' ? order.selectionId : null;

  return (
    <section id="kampagnen" data-testid="campaigns-section" className="chapter">
      <div className="wrap">
        <SectionHead
          n="05"
          eyebrow="Kampagnen"
          title="Für Marken und Erzeuger, deren Produkt bei uns im Regal steht."
          testid="campaigns-headline"
          lead="Hersteller, Winzer, Brauereien und regionale Produzenten: Bildschirm, Zweitplatzierung und Verkostung aus einer Hand – mit fester Laufzeit und festem Preis."
        />

        <Stagger className="mt-16 grid gap-5 md:grid-cols-2" data-testid="campaigns-grid">
          {CAMPAIGNS.map((c) => {
            const isSelected = selected === c.id;
            return (
              <Item
                key={c.id}
                as="article"
                data-testid={`campaign-card-${c.id}`}
                className={`group relative flex flex-col rounded-2xl border bg-[#16181D] p-7 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-[#FF6B00]/60 sm:p-9 ${
                  isSelected ? 'border-[#FF6B00] ring-2 ring-[#FF6B00] ring-offset-2 ring-offset-[#0F1012]' : 'border-[#282C37]'
                }`}
              >
                <div className="flex flex-wrap items-start justify-between gap-4">
                  <div>
                    <div className="flex flex-wrap items-center gap-2">
                      <h3 className="font-display text-2xl font-extrabold tracking-tight sm:text-3xl">{c.name}</h3>
                      {c.badge && <span className="rounded-full bg-[#FF6B00]/15 px-3 py-1 font-mono-num text-[10px] font-bold uppercase tracking-widest text-[#FF6B00]">{c.badge}</span>}
                      {isSelected && <span className="rounded-full bg-white px-3 py-1 font-mono-num text-[10px] font-bold uppercase tracking-widest text-[#0F1012]" data-testid={`campaign-selected-${c.id}`}>Ausgewählt</span>}
                    </div>
                    <p className="mt-1 font-mono-num text-[10px] uppercase tracking-widest text-[#7D8391]">{c.duration}</p>
                  </div>
                  <p className="shrink-0 text-right">
                    <span className="block font-mono-num text-3xl font-bold tracking-tighter text-white">{c.price.toLocaleString('de-DE')} €</span>
                    <span className="text-xs text-[#7D8391]">je Kampagne netto</span>
                  </p>
                </div>
                <p className="t-body mt-5 max-w-[56ch]">{c.desc}</p>
                <dl className="mt-6 flex-1 space-y-3 border-t border-[#282C37] pt-6 text-sm">
                  <div className="flex gap-3"><dt className="w-20 shrink-0 text-[#7D8391]">Zonen</dt><dd className="text-[#F9FAFB]">{c.zones}</dd></div>
                  {c.spot && <div className="flex gap-3"><dt className="w-20 shrink-0 text-[#7D8391]">Spot</dt><dd className="text-[#F9FAFB]">{c.spot}</dd></div>}
                  {c.extras && <div className="flex gap-3"><dt className="w-20 shrink-0 text-[#7D8391]">Inklusive</dt><dd className="text-[#F9FAFB]">{c.extras}</dd></div>}
                  <div className="flex gap-3"><dt className="w-20 shrink-0 text-[#7D8391]">Kontakte</dt><dd className="text-[#F9FAFB]">{c.contacts}</dd></div>
                </dl>
                <button type="button" data-testid={`campaign-select-${c.id}`} onClick={() => selectCampaign(c.id)} className="btn-ghost mt-7 self-start !px-5 !py-3">
                  Kampagne anfragen <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
                </button>
              </Item>
            );
          })}
        </Stagger>
      </div>
    </section>
  );
}
